<template>
  <a
    v-if="isExternalLink"
    :class="classes"
    :href="href"
    :role="variant ? 'button' : null"
    :aria-disabled="disabled ? 'true' : null"
    :tabindex="disabled ? '-1' : null"
  >
    <template v-if="icon">
      <i
        :class="[`bx ${icon}`, iconPos === 'right' && 'order-1']"
        aria-hidden="true"
      />
    </template>
    <slot />
  </a>
  <router-link v-else :class="classes">
    <template v-if="icon">
      <i
        :class="[`bx ${icon}`, iconPos === 'right' && 'order-1']"
        aria-hidden="true"
      />
    </template>
    <slot />
  </router-link>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import { BUTTON_VARIANTS, SIZES } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  href: { type: String, required: false },
  variant: {
    type: String,
    required: false,
    validator: (val) => ['', ...BUTTON_VARIANTS].includes(val),
  },
  size: {
    type: String,
    required: false,
    validator: (val) => SIZES.includes(val),
  },
  icon: { type: String, required: false },
  iconPos: {
    type: String,
    required: false,
    validator: (val) => ['left', 'right'].includes(val),
  },
  outline: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  class: { type: null, required: false },
})

const slots = useSlots()

const isExternalLink = computed(() => props.href)
const iconOnly = computed(() => !!(!slots.default && props.icon))
const classes = computed(() => {
  const baseClasses = []

  if (props.variant) {
    baseClasses.push(
      `btn btn-${props.outline ? 'outline-' : ''}${props.variant}`,
    )

    if (props.size) {
      baseClasses.push(`btn-${props.size}`)
    }

    if (props.disabled) {
      baseClasses.push('disabled')
    }

    if (iconOnly.value) {
      baseClasses.push('btn-icon')
    }
  } else if (props.disabled) {
    baseClasses.push('pe-none')
  }

  if (props.class) {
    baseClasses.push(props.class)
  }

  return baseClasses
})
</script>
